import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PageHeader from "../../../components/PageHeader";
import mainHelper, {apiCall} from "../../../helpers/MainHelper";
import ReactLoading from "react-loading";
import Swal from "sweetalert2";
import withPermissions from "../../../components/WithPermissions";

class StockTransferDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            transfer: null,
            isLoad: true,
            actionLoading: false
        }
    }

    componentDidMount() {
        this.fetchTransferDetail();
    }

    fetchTransferDetail = async () => {
        const {id} = this.props.match.params;
        try {
            const response = await apiCall(`business/stock/transfer/info/${id}`,'get');
            if(response.status === 'success') {
                this.setState({transfer: response.data, isLoad: false});
            }
        } catch (e) {
            console.error(e);
            this.setState({isLoad: false});
        }
    }

    handleApprove = async () => {
        const result = await Swal.fire({
            title: 'Transferi onaylamak istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, onayla!',
            cancelButtonText: 'Hayır, iptal et'
        });

        if (result.isConfirmed) {
            this.setState({actionLoading: true});
            try {
                const {id} = this.props.match.params;
                const response = await apiCall(`business/stock/transfer/approve/${id}`,'post');
                mainHelper.toastMessage(response.status, response.message);
                if(response.status === 'success') {
                    this.fetchTransferDetail();
                }
            } catch (e) {
                console.error(e);
            }
            this.setState({actionLoading: false});
        }
    }

    handleComplete = async () => {
        const result = await Swal.fire({
            title: 'Transferi tamamlamak istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#28a745',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, tamamla!',
            cancelButtonText: 'Hayır, iptal et'
        });

        if (result.isConfirmed) {
            this.setState({actionLoading: true});
            try {
                const {id} = this.props.match.params;
                const response = await apiCall(`business/stock/transfer/complete/${id}`,'post');
                mainHelper.toastMessage(response.status, response.message);
                if(response.status === 'success') {
                    this.fetchTransferDetail();
                }
            } catch (e) {
                console.error(e);
            }
            this.setState({actionLoading: false});
        }
    }

    handleCancel = async () => {
        const result = await Swal.fire({
            title: 'Transferi iptal etmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Evet, iptal et!',
            cancelButtonText: 'Hayır'
        });

        if (result.isConfirmed) {
            this.setState({actionLoading: true});
            try {
                const {id} = this.props.match.params;
                const response = await apiCall(`business/stock/transfer/cancel/${id}`,'post');
                mainHelper.toastMessage(response.status, response.message);
                if(response.status === 'success') {
                    this.fetchTransferDetail();
                }
            } catch (e) {
                console.error(e);
            }
            this.setState({actionLoading: false});
        }
    }

    getStatusLabel = (status) => {
        const statuses = {
            'pending': 'Beklemede',
            'approved': 'Onaylandı',
            'in_transit': 'Yolda',
            'completed': 'Tamamlandı',
            'cancelled': 'İptal Edildi'
        };
        return statuses[status] || status;
    }

    getStatusBadge = (status) => {
        const badges = {
            'pending': 'badge-warning',
            'approved': 'badge-info',
            'in_transit': 'badge-primary',
            'completed': 'badge-success',
            'cancelled': 'badge-danger'
        };
        return badges[status] || 'badge-secondary';
    }

    render() {
        const {transfer, isLoad, actionLoading} = this.state;
        const {userPermissions} = this.props;
        const canApprove = userPermissions.includes('stock.transfer.approve');
        const canComplete = userPermissions.includes('stock.transfer.complete');
        const canCancel = userPermissions.includes('stock.transfer.cancel');

        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div className="page-loader-wrapper" style={{display: isLoad ? 'block' : 'none'}}>
                    <div className="loader" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <div className="m-t-30">
                            <img src={require('../../../assets/images/logo-white.png')} width="150" alt="Servicezone"/>
                        </div>
                        <p>Yükleniyor</p>
                        <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff"/>
                    </div>
                </div>
                {!isLoad && !transfer && (
                    <div className="text-center p-5">Transfer bulunamadı.</div>
                )}
                {!isLoad && transfer && (
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Transfer Detay"
                            Breadcrumb={[
                                { name: "Stok Yönetimi", navigate: "" },
                                { name: "Transferler", navigate: "stock/transfers" },
                                { name: "Transfer Detay", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <div className="col-lg-8 col-md-12">
                                <div className="card">
                                    <div className="header">
                                        <h2>Transfer Bilgileri</h2>
                                        <span className={`badge ${this.getStatusBadge(transfer.status)} float-right`}>
                                            {this.getStatusLabel(transfer.status)}
                                        </span>
                                    </div>
                                    <div className="body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <p><strong>Transfer No:</strong> {transfer.transfer_number}</p>
                                                <p><strong>Kaynak Depo:</strong> {transfer.from_warehouse ? transfer.from_warehouse.name : '-'}</p>
                                                <p><strong>Hedef Depo:</strong> {transfer.to_warehouse ? transfer.to_warehouse.name : '-'}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <p><strong>Transfer Tarihi:</strong> {transfer.transfer_date ? new Date(transfer.transfer_date).toLocaleDateString('tr-TR') : '-'}</p>
                                                <p>
                                                    <strong>Talep Eden:</strong> {transfer.requested_by ? (
                                                        <span>
                                                            {transfer.requested_by.name+' '+transfer.requested_by.surname}
                                                            {transfer.requested_by.email && <small className="text-muted d-block">{transfer.requested_by.email}</small>}
                                                        </span>
                                                    ) : '-'}
                                                </p>
                                                <p>
                                                    <strong>Onaylayan:</strong> {transfer.approved_by ? (
                                                        <span>
                                                            {transfer.approved_by.name+' '+transfer.approved_by.surname}
                                                            {transfer.approved_by.email && <small className="text-muted d-block">{transfer.approved_by.email}</small>}
                                                        </span>
                                                    ) : <span className="text-warning">Henüz onaylanmadı</span>}
                                                </p>
                                            </div>
                                        </div>
                                        {transfer.notes && (
                                            <div className="row mt-3">
                                                <div className="col-12">
                                                    <p><strong>Notlar:</strong></p>
                                                    <p className="text-muted">{transfer.notes}</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="card">
                                    <div className="header">
                                        <h2>Transfer Kalemleri</h2>
                                    </div>
                                    <div className="body">
                                        <div className="table-responsive">
                                            <table className="table table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>Stok Kalemi</th>
                                                        <th>SKU</th>
                                                        <th className="text-right">İstenen Miktar</th>
                                                        <th className="text-right">Transfer Edilen</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {transfer.items && transfer.items.length > 0 ? transfer.items.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.stock_item ? item.stock_item.name : '-'}</td>
                                                            <td>{item.stock_item && item.stock_item.sku ? item.stock_item.sku : '-'}</td>
                                                            <td className="text-right"><strong>{Math.round(item.quantity || 0)}</strong></td>
                                                            <td className="text-right text-success">{Math.round(item.transferred_quantity || 0)}</td>
                                                        </tr>
                                                    )) : (
                                                        <tr>
                                                            <td colSpan="4" className="text-center">Kalem bulunamadı</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div className="card">
                                    <div className="body">
                                        <div className="row">
                                            <div className="col-12">
                                                <button
                                                    className="btn btn-secondary mr-2"
                                                    onClick={() => this.props.history.push('/stock/transfers')}
                                                    disabled={actionLoading}
                                                >
                                                    <i className="icon-arrow-left"></i> Geri Dön
                                                </button>

                                                {transfer.status === 'pending' && canApprove && (
                                                    <button
                                                        className="btn btn-info mr-2"
                                                        onClick={this.handleApprove}
                                                        disabled={actionLoading}
                                                    >
                                                        {actionLoading ? <ReactLoading type="spin" width={'20px'} height={'20px'} /> : <><i className="icon-check"></i> Onayla</>}
                                                    </button>
                                                )}

                                                {(transfer.status === 'approved' || transfer.status === 'in_transit') && canComplete && (
                                                    <button
                                                        className="btn btn-success mr-2"
                                                        onClick={this.handleComplete}
                                                        disabled={actionLoading}
                                                    >
                                                        {actionLoading ? <ReactLoading type="spin" width={'20px'} height={'20px'} /> : <><i className="icon-check"></i> Tamamla</>}
                                                    </button>
                                                )}

                                                {(transfer.status === 'pending' || transfer.status === 'approved') && canCancel && (
                                                    <button
                                                        className="btn btn-danger"
                                                        onClick={this.handleCancel}
                                                        disabled={actionLoading}
                                                    >
                                                        {actionLoading ? <ReactLoading type="spin" width={'20px'} height={'20px'} /> : <><i className="icon-close"></i> İptal Et</>}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = ({stockReducer}) => ({});

export default withPermissions(withRouter(connect(mapStateToProps, {})(StockTransferDetail)));

